(() => {
  const init = (root) => {
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const observeSel = root.dataset.observe || '';
    const anchor = observeSel ? document.querySelector(observeSel) : null;
    const atcBtn = root.querySelector('[data-yh-sticky-atc]');
    const buyBtn = root.querySelector('[data-yh-sticky-buy]');
    const atcLabel = root.querySelector('[data-yh-sticky-atc-label]');
    const saleEl = root.querySelector('[data-yh-sticky-sale]');
    const offEl = root.querySelector('[data-yh-sticky-off]');
    const priceId = root.dataset.priceId || '';
    const priceRoot = priceId ? document.getElementById(priceId) : null;

    let hideTimer = null;

    const findFooter = () =>
      document.querySelector('.shopify-section-group-footer-group') ||
      document.querySelector('#shopify-section-footer') ||
      document.querySelector('footer.footer') ||
      document.querySelector('.footer');

    const footerEl = findFooter();

    const setVisible = (visible) => {
      clearTimeout(hideTimer);
      if (visible) {
        root.hidden = false;
        root.setAttribute('aria-hidden', 'false');
        requestAnimationFrame(() => {
          root.classList.add('is-visible');
          document.body.classList.add('yh-pdp-sticky-cta-active');
        });
        return;
      }
      root.classList.remove('is-visible');
      root.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('yh-pdp-sticky-cta-active');
      hideTimer = setTimeout(() => {
        if (!root.classList.contains('is-visible')) root.hidden = true;
      }, 320);
    };

    const measureNearFooter = () => {
      if (!footerEl) return false;
      const viewH = window.innerHeight || 0;
      const rect = footerEl.getBoundingClientRect();
      return rect.top < viewH - 8;
    };

    const measurePastCta = () => {
      if (!anchor) return window.scrollY > 360;
      const rect = anchor.getBoundingClientRect();
      return rect.bottom < 8;
    };

    const syncVisibility = () => {
      if (window.matchMedia('(min-width: 750px)').matches) {
        setVisible(false);
        return;
      }
      setVisible(measurePastCta() && !measureNearFooter());
    };

    const syncPrice = () => {
      if (!saleEl || !priceRoot) return;
      const sale =
        priceRoot.querySelector('.price-item--sale') ||
        priceRoot.querySelector('.price-item--regular');
      if (sale) {
        saleEl.textContent = sale.textContent.replace(/\s+/g, ' ').trim();
      }
      const badge = priceRoot.querySelector('.price__badge-sale--discount, .price__badge-sale');
      if (offEl) {
        const text = badge?.textContent?.replace(/\s+/g, ' ').trim() || '';
        if (text) {
          offEl.textContent = text;
          offEl.classList.remove('is-hidden');
        } else {
          offEl.classList.add('is-hidden');
        }
      }
    };

    const syncDisabled = () => {
      const realAtc = atcBtn?.dataset.target
        ? document.getElementById(atcBtn.dataset.target)
        : null;
      const realBuy = buyBtn?.dataset.target
        ? document.getElementById(buyBtn.dataset.target)
        : null;

      if (atcBtn && realAtc) {
        atcBtn.disabled = realAtc.disabled || realAtc.getAttribute('aria-disabled') === 'true';
        if (atcLabel) {
          const text = realAtc.querySelector('.yh-pdp__atc-label')?.textContent?.trim();
          if (text) atcLabel.textContent = text.replace(/\s+/g, ' ');
        }
      }
      if (buyBtn && realBuy) {
        buyBtn.disabled = realBuy.disabled || realBuy.getAttribute('aria-disabled') === 'true';
      }
    };

    const syncAll = () => {
      syncDisabled();
      syncPrice();
    };

    const clickTarget = (btn) => {
      const id = btn?.dataset.target;
      if (!id) return;
      const target = document.getElementById(id);
      if (!target || target.disabled || target.getAttribute('aria-disabled') === 'true') return;
      target.click();
    };

    atcBtn?.addEventListener('click', () => clickTarget(atcBtn));
    buyBtn?.addEventListener('click', () => clickTarget(buyBtn));

    root.classList.remove('is-visible');
    root.hidden = true;
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('yh-pdp-sticky-cta-active');

    let tick = false;
    const onScrollOrResize = () => {
      if (tick) return;
      tick = true;
      requestAnimationFrame(() => {
        tick = false;
        syncVisibility();
        syncAll();
      });
    };

    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize, { passive: true });

    if ('IntersectionObserver' in window && anchor) {
      const io = new IntersectionObserver(() => syncVisibility(), {
        threshold: [0, 0.01, 0.1, 1],
      });
      io.observe(anchor);
    }

    if ('IntersectionObserver' in window && footerEl) {
      const fio = new IntersectionObserver(() => syncVisibility(), {
        rootMargin: '0px 0px 80px 0px',
        threshold: [0, 0.01, 0.1],
      });
      fio.observe(footerEl);
    }

    document.addEventListener('variant:change', syncAll);
    document.addEventListener('change', (e) => {
      if (e.target?.closest?.('variant-selects, variant-radios, product-info')) {
        requestAnimationFrame(syncAll);
      }
    });

    const realAtc = atcBtn?.dataset.target
      ? document.getElementById(atcBtn.dataset.target)
      : null;
    if (realAtc && 'MutationObserver' in window) {
      const mo = new MutationObserver(syncAll);
      mo.observe(realAtc, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
    }

    if (priceRoot && 'MutationObserver' in window) {
      const po = new MutationObserver(syncPrice);
      po.observe(priceRoot, { childList: true, subtree: true, characterData: true });
    }

    syncAll();
    syncVisibility();
  };

  const boot = () => {
    document.querySelectorAll('[data-yh-pdp-sticky-cta]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const el =
      event.target?.querySelector?.('[data-yh-pdp-sticky-cta]') || event.target;
    if (el?.matches?.('[data-yh-pdp-sticky-cta]')) {
      el.dataset.ready = 'false';
      init(el);
    }
  });
})();
